export default class FSalesmanFilter {
  constructor(
      isFirstLoad = true,

      id = 0,
      pageNo= 1,
      pageSize = 10,
      sortBy="id",
      order="DESC",
      search="",


      fdivisionIds =[],
      statusActive= 0,

  ) {

    this.id = id;
    this.isFirstLoad = isFirstLoad;
    this.pageNo = pageNo;
    this.pageSize = pageSize;
    this.sortBy = sortBy;
    this.order = order;
    this.search = search;

    this.fdivisionIds = fdivisionIds;
    this.statusActive = statusActive
  }

}
